import React from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useLocale } from "../context/LocaleContext";
import "../styles/root.css";

const REPORTS = [
  {
    year: 2025,
    file: "/documents/annual-reports/anisija-annual-report-2025.pdf",
    available: true,
  },
  {
    year: 2024,
    file: "/documents/annual-reports/anisija-annual-report-2024.pdf",
    available: false,
  },
  {
    year: 2023,
    file: "/documents/annual-reports/anisija-annual-report-2023.pdf",
    available: false,
  },
];

function EyeSlashIcon() {
  return (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
      <path d="M3 3l18 18" />
      <path d="M10.6 10.6a2 2 0 102.8 2.8" />
      <path d="M9.9 5.4A11 11 0 0112 5c5.6 0 9.2 5.1 9.7 5.8a1 1 0 010 1.2c-.4.6-2.6 3.8-6.2 5.2" />
      <path d="M6.2 6.2C3.9 7.7 2.5 9.7 2.3 10a1 1 0 000 1.2C2.8 11.9 6.4 17 12 17c.8 0 1.6-.1 2.3-.3" />
    </svg>
  );
}

function AnnualReports() {
  const { t } = useLocale();

  return (
    <div>
      <Navbar />
      <div className="home-container">
        <h1 className="headline">{t.annualReports.headline}</h1>
        <p className="reports-intro">{t.annualReports.intro}</p>

        <section className="reports-grid">
          {REPORTS.map((report) => {
            const reportTitle = `${t.annualReports.reportTitlePrefix} ${report.year}`;

            return (
              <article
                key={report.year}
                className={`report-card${report.available ? "" : " unavailable"}`}
              >
                <h2>{reportTitle}</h2>
                <p className="report-meta">{t.annualReports.formatLabel}</p>

                {report.available ? (
                  <div className="report-actions">
                    <a
                      href={report.file}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="report-action-link"
                    >
                      {t.annualReports.open}
                    </a>
                    <a
                      href={report.file}
                      download
                      className="report-action-link"
                    >
                      {t.annualReports.download}
                    </a>
                  </div>
                ) : (
                  <div className="report-unavailable-overlay" aria-live="polite">
                    <span className="report-unavailable-icon" aria-hidden="true">
                      <EyeSlashIcon />
                    </span>
                    <p className="report-unavailable-message">
                      {t.annualReports.unavailable}
                    </p>
                  </div>
                )}
              </article>
            );
          })}
        </section>
      </div>
      <Footer />
    </div>
  );
}

export default AnnualReports;
